import { render, staticRenderFns } from "./menuSettings.vue?vue&type=template&id=2ea9113e&scoped=true&"
import script from "./menuSettings.vue?vue&type=script&lang=js&"
export * from "./menuSettings.vue?vue&type=script&lang=js&"
import style0 from "./menuSettings.vue?vue&type=style&index=0&id=2ea9113e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9113e",
  null
  
)

export default component.exports